import React from 'react';
import { X, ArrowRight, CheckCircle2 } from 'lucide-react';
import { Service } from '../types';
import '../styles/ServiceModal.css';

interface ServiceModalProps {
  service: Service | null;
  isOpen: boolean;
  onClose: () => void;
  onBookConsultation: () => void;
}

const ServiceModal: React.FC<ServiceModalProps> = ({ service, isOpen, onClose, onBookConsultation }) => {
  if (!isOpen || !service) return null;

  const IconComponent = service.icon;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close modal">
          <X size={24} />
        </button>

        <div className="modal-header">
          <div className="modal-icon">
            <IconComponent size={32} />
          </div>
          <h2>{service.title}</h2>
          <p className="modal-subtitle">{service.description}</p>
        </div>

        <div className="modal-body">
          {/* Full Description */}
          <section className="modal-section">
            <h3>Overview</h3>
            <div className="overview-text">
              {service.fullDescription?.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </section>

          {/* Key Benefits */}
          <section className="modal-section">
            <h3>Key Benefits</h3>
            <ul className="benefits-list">
              {service.benefits?.map((benefit, index) => (
                <li key={index}>
                  <CheckCircle2 size={20} className="check-icon" />
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Use Cases */}
          <section className="modal-section">
            <h3>Use Cases</h3>
            <div className="use-cases-grid">
              {service.useCases?.map((useCase, index) => (
                <div key={index} className="use-case-card">
                  <h4>{useCase.title}</h4>
                  <p>{useCase.description}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Tech Stack */}
          <section className="modal-section">
            <h3>Technology Stack</h3>
            <div className="tech-stack">
              {service.techStack?.map((tech, index) => (
                <span key={index} className="tech-badge">{tech}</span>
              ))}
            </div>
          </section>
        </div>

        <div className="modal-footer">
          <button className="btn-outline" onClick={onClose}>
            Close
          </button>
          <button className="btn-primary" onClick={onBookConsultation}>
            Book Consultation <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;
